import { Clue } from '@/api/interface/clue'
import { PORT } from '@/api/config/servicePort'
import http from '@/api'
// import { promises } from 'dns'
// import { resolve } from 'path'
// import { PORT1 } from '@/api/config/servicePort'

/**
 * @name 留资模块
 */
// * 线索新增
export const clueFormAddApi = (params: Clue.ReqClueForm) => {
  return http.post<{ [key: string]: any }>(PORT + `/lead/save`, params) // 正常 post json 请求  ==>  application/json
}
